import { render } from "./bulletinNotes.vue?vue&type=template&id=04794e9b"
import script from "./bulletinNotes.vue?vue&type=script&lang=js"
export * from "./bulletinNotes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/bulletin/bulletinNotes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04794e9b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04794e9b', __exports__)) {
    console.log('reload')
    api.reload('04794e9b', __exports__)
  }
  
  module.hot.accept("./bulletinNotes.vue?vue&type=template&id=04794e9b", () => {
    console.log('re-render')
    api.rerender('04794e9b', render)
  })

}


export default __exports__